export const SITE_CONFIG = {
  name: 'Nagendra Vikram Dixit',
  role: 'Enterprise AI Agent Builder · Automation Engineer · Senior Backend Engineer',
  location: 'Rugby & Leeds, UK',
  githubUrl: 'https://github.com/nagendradixit647',
  defaultLinkedinUrl: 'https://www.linkedin.com/in/nvdixit/',
  defaultLinkedinVanity: 'nvdixit',
} as const;

export default SITE_CONFIG;
